import React from 'react';
import '../../scss/components/Card.scss';

interface CardProps {
    children:any,
    p?:number|string,
    pX?:number|string,
    pY?:number|string,
    gap?:number|string,
    backgroundColor?:number|string,
    borderRadius?:number|string,
    boxShadow?:number|string,
    className?:string,
}

const Card = ({
    children,
    p,
    pX,
    pY,
    gap,
    backgroundColor,
    borderRadius,
    boxShadow,
    className
}:CardProps) => {
    let cardStyle = {};
    cardStyle = {
        ...cardStyle,
        ...(p && {padding: p}), //Optional Value that can be assigned
        ...(pX && {paddingLeft: pX}), //Optional Value that can be assigned
        ...(pX && {paddingRight: pX}), //Optional Value that can be assigned
        ...(pY && {paddingTop: pY}), //Optional Value that can be assigned
        ...(pY && {paddingBottom: pY}), //Optional Value that can be assigned
        ...(gap && {gap: gap}), //Optional Value that can be assigned
        ...(backgroundColor ? {backgroundColor: backgroundColor} : {backgroundColor: 'var(--color-background-light)'}), //Optional Value that can be assigned or else is set to a default
        ...(borderRadius ? {borderRadius: borderRadius} : {borderRadius: 'var(--border-radius-xs)'}), //Optional Value that can be assigned or else is set to a default
        ...(boxShadow && {boxShadow: boxShadow}), //Optional Value that can be assigned
    }
    return (
        <div className="card-container">
            <div className={['card',className].join(' ')} style={cardStyle}>
                {children}
            </div>
        </div>
    )
}

export default Card;